(function () {
  'use strict';

  // === HELPERS ===

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  // Format a number back into the original currency string shape.
  // Examples: original "$39" + 33.15 => "$33.15"
  //           original "39 USD" + 33.15 => "33.15 USD"
  //           original "€39,00" + 33.15 => "€33,15" (best-effort)
  function formatPriceLike(template, value) {
    if (typeof template !== 'string') return String(value);
    var match = template.match(/([^\d.,\-]*)(-?\d[\d.,]*)([^\d.,]*)/);
    if (!match) return value.toFixed(2);
    var prefix = match[1] || '';
    var numStr = match[2] || '';
    var suffix = match[3] || '';
    var usesComma = numStr.indexOf(',') > -1 && numStr.lastIndexOf(',') > numStr.lastIndexOf('.');
    var hasDecimals = /[.,]\d{1,2}$/.test(numStr);
    var formatted;
    if (hasDecimals || value % 1 !== 0) {
      formatted = value.toFixed(2);
      if (usesComma) formatted = formatted.replace('.', ',');
    } else {
      formatted = String(Math.round(value));
    }
    return prefix + formatted + suffix;
  }

  function parsePriceFromText(text) {
    if (!text) return NaN;
    var cleaned = String(text).replace(/[^\d.,\-]/g, '');
    // If both . and , present, assume the last one is the decimal separator
    var lastDot = cleaned.lastIndexOf('.');
    var lastComma = cleaned.lastIndexOf(',');
    if (lastDot > -1 && lastComma > -1) {
      if (lastComma > lastDot) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (lastComma > -1) {
      // Only commas — treat as decimal if 1-2 digits after
      if (/,\d{1,2}$/.test(cleaned)) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    }
    return parseFloat(cleaned);
  }

  // === GALLERY ===

  function initGallery() {
    var root = $('.shudoprod');
    if (!root) return;
    var thumbs = $$('.shudoprod-gallery__thumb', root);
    var mainImg = $('.shudoprod-gallery__main img', root);
    if (!thumbs.length || !mainImg) return;

    function swap(thumb) {
      var src = thumb.getAttribute('data-image-src');
      if (!src) {
        var innerImg = $('img', thumb);
        if (innerImg) src = innerImg.getAttribute('src');
      }
      if (!src) return;
      if (mainImg.getAttribute('src') === src) {
        thumbs.forEach(function (t) { t.classList.toggle('active', t === thumb); });
        return;
      }
      mainImg.style.transition = 'opacity 180ms ease';
      mainImg.style.opacity = '0';
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.setAttribute('src', src);
        // Force reflow so the opacity transition restarts cleanly
        void mainImg.offsetWidth;
        mainImg.style.opacity = '1';
      };
      var onEnd = function () {
        mainImg.removeEventListener('transitionend', onEnd);
        finish();
      };
      mainImg.addEventListener('transitionend', onEnd);
      setTimeout(finish, 220);

      thumbs.forEach(function (t) { t.classList.toggle('active', t === thumb); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        swap(thumb);
      });
    });
  }

  // === TABS ===

  function initTabs() {
    var root = $('.shudoprod');
    if (!root) return;
    var tabs = $$('.shudoprod-tab', root);
    var panels = $$('.shudoprod-panel', root);
    if (!tabs.length || !panels.length) return;

    function activate(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === name;
        t.classList.toggle('active', on);
        if (t.hasAttribute('role')) t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p) {
        p.classList.toggle('active', p.getAttribute('data-panel') === name);
      });
    }

    // Ensure initial state is consistent — first tab/panel active if nothing is.
    var hasActive = tabs.some(function (t) { return t.classList.contains('active'); });
    if (!hasActive) {
      var firstName = tabs[0].getAttribute('data-tab');
      if (firstName) activate(firstName);
    } else {
      // Mirror markup state to panels in case they're out of sync.
      var activeTab = tabs.find(function (t) { return t.classList.contains('active'); });
      if (activeTab) activate(activeTab.getAttribute('data-tab'));
    }

    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var name = tab.getAttribute('data-tab');
        if (name) activate(name);
      });

      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var dir = e.key === 'ArrowRight' ? 1 : -1;
        var next = (idx + dir + tabs.length) % tabs.length;
        var nextTab = tabs[next];
        var name = nextTab.getAttribute('data-tab');
        if (name) activate(name);
        nextTab.focus();
      });
    });
  }

  // === SUBSCRIPTION ===

  var SUB_DISCOUNT = 0.85; // 15% off

  function initSubscription() {
    var root = $('.shudoprod');
    if (!root) return;
    var btns = $$('.shudoprod-sub__btn', root);
    var priceEl = $('.shudoprod-info__price', root);
    if (!btns.length || !priceEl) return;

    var strikeEl = $('.shudoprod-info__price--strike', root);
    var savingsEl = $('.shudoprod-info__savings', root);
    var ctaEl = $('.shudoprod-cta', root);
    var ctaPriceEl = $('.shudoprod-cta__price', root);
    var stickyPriceEl = $('.shudoprod-sticky-bar__price', root);

    // Resolve base price (numeric) and the original textual template
    var basePriceAttr = priceEl.getAttribute('data-base-price');
    var basePrice;
    var template = priceEl.textContent.trim();
    if (basePriceAttr && !isNaN(parseFloat(basePriceAttr))) {
      basePrice = parseFloat(basePriceAttr);
    } else {
      basePrice = parsePriceFromText(template);
      if (!isNaN(basePrice)) {
        priceEl.setAttribute('data-base-price', String(basePrice));
      }
    }
    if (isNaN(basePrice)) return;

    // Cache the original CTA text shape for the price portion
    var ctaTemplate = ctaEl ? ctaEl.textContent.trim() : '';

    function setMode(mode) {
      var isSub = mode === 'subscribe';
      var current = isSub ? basePrice * SUB_DISCOUNT : basePrice;
      var formatted = formatPriceLike(template, current);

      // Update main price
      priceEl.textContent = formatted;

      // Strike + savings visibility
      if (strikeEl) {
        if (isSub) {
          strikeEl.textContent = formatPriceLike(template, basePrice);
          strikeEl.style.display = '';
          strikeEl.removeAttribute('hidden');
        } else {
          strikeEl.style.display = 'none';
        }
      }
      if (savingsEl) {
        if (isSub) {
          savingsEl.style.display = '';
          savingsEl.removeAttribute('hidden');
        } else {
          savingsEl.style.display = 'none';
        }
      }

      // CTA price — only update the inner price span, never the whole button
      if (ctaPriceEl) {
        ctaPriceEl.textContent = '— ' + formatted;
      } else if (ctaEl) {
        var ctaText;
        if (/[—–-]\s*[^\s]+\s*$/.test(ctaTemplate)) {
          ctaText = ctaTemplate.replace(/([—–-])\s*[^\s]+\s*$/, '$1 ' + formatted);
        } else {
          ctaText = 'ADD TO CART — ' + formatted;
        }
        ctaEl.textContent = ctaText;
      }

      // Sticky mirror
      if (stickyPriceEl) {
        stickyPriceEl.textContent = formatted;
      }

      // Buttons aria + active
      btns.forEach(function (b) {
        var on = b.getAttribute('data-mode') === mode;
        b.classList.toggle('active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var mode = b.getAttribute('data-mode');
        if (mode) setMode(mode);
      });
    });

    // Initial state — honor markup if a button is already .active
    var initial = btns.find(function (b) { return b.classList.contains('active'); });
    var initialMode = initial ? initial.getAttribute('data-mode') : 'onetime';
    setMode(initialMode || 'onetime');
  }

  // === QUANTITY ===

  function initQuantity() {
    var root = $('.shudoprod');
    if (!root) return;
    var qtyWrap = $('.shudoprod-qty', root);
    if (!qtyWrap) return;
    var input = $('input', qtyWrap);
    var dec = qtyWrap.querySelector('[data-qty="decrement"]');
    var inc = qtyWrap.querySelector('[data-qty="increment"]');
    if (!input) return;

    function clamp(n) {
      n = parseInt(n, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    function set(n) {
      input.value = String(clamp(n));
    }

    if (dec) {
      dec.addEventListener('click', function (e) {
        e.preventDefault();
        set(parseInt(input.value, 10) - 1);
      });
    }
    if (inc) {
      inc.addEventListener('click', function (e) {
        e.preventDefault();
        set(parseInt(input.value, 10) + 1);
      });
    }
    input.addEventListener('change', function () { set(input.value); });
    input.addEventListener('blur', function () { set(input.value); });

    // Initial clamp
    set(input.value || 1);
  }

  // === ADD TO CART ===

  function initAddToCart() {
    var root = $('.shudoprod');
    if (!root) return;
    var mainBtn = $('.shudoprod-cta', root);
    var stickyBtn = $('.shudoprod-sticky-bar__btn', root);
    if (!mainBtn && !stickyBtn) return;

    var busy = false;

    function getVariantId(btn) {
      var id = btn && btn.getAttribute('data-variant-id');
      if (id) return id;
      var hidden = root.querySelector('input[name="id"]');
      if (hidden && hidden.value) return hidden.value;
      return null;
    }

    function getQty() {
      var input = $('.shudoprod-qty input', root);
      if (!input) return 1;
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    function getSellingPlan() {
      var active = root.querySelector('.shudoprod-sub__btn.active');
      if (!active) return null;
      if (active.getAttribute('data-mode') !== 'subscribe') return null;
      var plan = active.getAttribute('data-selling-plan-id');
      return plan || null;
    }

    function flash(btn, text, bg, ms) {
      if (!btn) return;
      if (!btn.hasAttribute('data-default-html')) {
        btn.setAttribute('data-default-html', btn.innerHTML);
      }
      if (!btn.hasAttribute('data-default-bg')) {
        btn.setAttribute('data-default-bg', btn.style.backgroundColor || '');
      }
      btn.textContent = text;
      if (bg) btn.style.backgroundColor = bg;
      setTimeout(function () {
        btn.innerHTML = btn.getAttribute('data-default-html') || '';
        btn.style.backgroundColor = btn.getAttribute('data-default-bg') || '';
      }, ms || 2200);
    }

    function refreshCartCount() {
      if (!window.fetch) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          var count = data.item_count != null ? data.item_count : 0;
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = String(count);
          });
        })
        .catch(function () { /* no-op */ });
    }

    function handle(btn) {
      if (busy) return;
      if (!btn) return;
      busy = true;

      var variantId = getVariantId(btn) || getVariantId(mainBtn);
      var quantity = getQty();
      var plan = getSellingPlan();

      // Preview mode — no variant id; simulate success
      if (!variantId) {
        flash(btn, '✓ ADDED', 'var(--green-mid)', 2200);
        setTimeout(function () { busy = false; }, 2200);
        return;
      }

      if (!window.fetch) {
        flash(btn, 'ERROR — TRY AGAIN', '', 2200);
        setTimeout(function () { busy = false; }, 2200);
        return;
      }

      var body = { id: variantId, quantity: quantity };
      if (plan) body.selling_plan = plan;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add failed: ' + res.status);
          return res.json();
        })
        .then(function () {
          flash(btn, '✓ ADDED', 'var(--green-mid)', 2200);
          refreshCartCount();
          setTimeout(function () { busy = false; }, 2200);
        })
        .catch(function () {
          flash(btn, 'ERROR — TRY AGAIN', '', 2200);
          setTimeout(function () { busy = false; }, 2200);
        });
    }

    // Event delegation — single handler scoped to the section root
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('.shudoprod-cta, .shudoprod-sticky-bar__btn');
      if (!btn || !root.contains(btn)) return;
      // If inside a form, prevent native submit
      e.preventDefault();
      handle(btn);
    });
  }

  // === STICKY BAR ===

  function initStickyBar() {
    var root = $('.shudoprod');
    if (!root) return;
    var bar = $('.shudoprod-sticky-bar', root);
    var mainCta = $('.shudoprod-cta', root);
    if (!bar || !mainCta) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback — leave bar hidden, no scroll behavior
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('visible');
        } else {
          bar.classList.add('visible');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    observer.observe(mainCta);
  }

  // === FAQ ===

  function initFaq() {
    var root = $('.shudoprod');
    if (!root) return;
    var items = $$('details', root);
    if (!items.length) return;

    items.forEach(function (item) {
      var summary = $('summary', item);
      if (!summary) return;
      summary.addEventListener('click', function () {
        // If this one is about to open, close siblings.
        if (item.open) return; // already open — native will close it
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  // === REVEAL ===

  function initReveal() {
    var els = $$('.shudoprod-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  // === BOOT ===

  ready(function () {
    initGallery();
    initTabs();
    initSubscription();
    initQuantity();
    initAddToCart();
    initStickyBar();
    initFaq();
    initReveal();
  });
})();
